import { Community } from "@/interfaces/courses/communities/Community";
import { ref } from "vue";

export const communities = ref<Community[]>()